import { gql } from 'src/__generated__';

const CREATE_ACTIVITY_LOGS = gql(`
  mutation CreateActivityLogV2(
    $activity: String!
  ) {
    createActivityLogV2(
      activity: $activity
    ) {
      id
    }
  }
`);

export default CREATE_ACTIVITY_LOGS;
